import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { ActionSheetController, IonContent, LoadingController, ModalController, Platform, ToastController } from '@ionic/angular';
import { EmployeeVoiceService } from 'src/app/services/employee-voice.service';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File, FileEntry } from '@ionic-native/file/ngx';
import { WebView } from '@ionic-native/ionic-webview/ngx';
import { StatusHttp } from 'src/app/static';

@Component({
  selector: 'app-view-employee-voice',
  templateUrl: './view-employee-voice.page.html',
  styleUrls: ['./view-employee-voice.page.scss'],
})
export class ViewEmployeeVoicePage implements OnInit {
@ViewChild('content', { static: false }) content: IonContent;

  @Input() message:any;
  comment:any;
  response;
  formData  = new FormData();
  nativeImageUrl:string;
  image:any;
  imageArray:any = [];
  voiceEmployee:string;
  selectSubject: string = '';
  private readonly otherInputValue = '11';
  otherSubject: string = '';
  voiceEmployeeData:any;
  active: boolean = false;
  isLoading: boolean = false;
  typePlatform:string;
  fileData:any;

  optionsCamera: CameraOptions = {
    quality:40,
    destinationType: this.camera.DestinationType.FILE_URI,
    sourceType: this.camera.PictureSourceType.CAMERA,
    mediaType: this.camera.MediaType.PICTURE,
    correctOrientation: true,
    encodingType: this.camera.EncodingType.JPEG,
    allowEdit:false
  }

  optionsGallery: CameraOptions = {
    quality: 40,
    destinationType: this.camera.DestinationType.FILE_URI,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    allowEdit:false,
    correctOrientation: true,
    sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    saveToPhotoAlbum: true
  }

  constructor(
    private modalController:ModalController, 
    private employeeService:EmployeeVoiceService, 
    private router:Router,    
    private platform: Platform,
    public actionSheetController: ActionSheetController,
    private androidPermissions: AndroidPermissions,
    private camera: Camera,
    private file: File,
    private toastController:ToastController,
    private webview: WebView,
    public loadingCtrl: LoadingController,
  ) { 
    if(this.platform.is('desktop') || this.platform.is('mobileweb')){
      this.typePlatform = 'browser';
      console.log('browser');
    } else {
      this.typePlatform = 'app';
      console.log('app');
    }
  }


  async ngOnInit() {
    this.presentLoading();
    await this.getComment();
    this.dismissLoading();
  }
  getComment(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.employeeService.getComment(this.message.id).subscribe({
        next: (res: any) => {
          this.comment = res.data;
          this.comment.extra_voice_employee = this.comment.extra_voice_employee.slice().reverse();
          // Espera a que el DOM se actualice antes de hacer scroll
          setTimeout(() => {
            this.scrollToBottom();
          }, 300);
          resolve();
        },
        error: (err) => reject(err)
      });
    });
  }
  close(){
    this.modalController.dismiss();
  }

  reOpen(message){
    this.modalController.dismiss();
    this.router.navigate(["employee-voice/send-voice", { data: JSON.stringify(message)}]);
  }

  //funciones para foto
  async openOptions() {
    let action_buttons = [];
    if (this.platform.is('android')) {
      action_buttons = [
        { 
          text: 'Tomar foto',          
          handler: () => {
            this.takePicture();
            console.log('tomar foto clicked');
          }  
        },
        { 
          text: 'Seleccionar de galería',        
          handler: () => {
            this.getGalleryPicture();
            console.log('galeria clicked');
          } 
        },
        { text: 'Cancelar', role: 'cancel' }
      ];
    }else{
      action_buttons = [
        { 
          text: 'Tomar foto',          
          handler: () => {
            this.takePicture();
            console.log('tomar foto clicked');
          }  
        },
        { 
          text: 'Seleccionar de galería',        
          handler: () => {
            this.getGalleryPicture();
            console.log('galeria clicked');
          } 
        },
        { text: 'Cancelar', role: 'cancel' }
      ]; 
    }
    const actionSheet = await this.actionSheetController.create({
      header: 'Selecciona una opción',
      buttons: action_buttons
    });
    await actionSheet.present();
  }

    async takePicture(){
  
      if (this.platform.is('android')) {
        console.log('android');
        // To be able to save files on Android, we first need to ask the user for permission. 
        // We do not let the download proceed until they grant access
        await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA).then(
          result => {
            if (!result.hasPermission) {
              return this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA);
            }
          }
        );
      }
  
      this.camera.getPicture(this.optionsCamera).then((imageURL) => {
        // imageData is either a base64 encoded string or a file URI
        // If it's base64 (DATA_URL):
        this.file.resolveLocalFilesystemUrl(imageURL)
        .then( (entry) => { 
          console.log(entry.toURL());
          (<FileEntry>entry).file(file => {
            // this is the actual file as File object
            this.readFile(file);
          });
          this.presentToast('Imagen cargada','success');
          this.nativeImageUrl = entry.toURL();
          this.image = this.webview.convertFileSrc(entry.toURL());
          this.imageArray.push(this.image);
          console.log(this.image);
        })
        .catch(err => {
          this.presentToast('File path resolver error: '+JSON.stringify(err),'danger')
        });
       }, (err) => {
        // Handle error
        this.presentToast('Get image from camera error: '+JSON.stringify(err),'danger')
       });
  }
  getGalleryPicture(){
    this.camera.getPicture(this.optionsGallery).then((imageURL) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64 (DATA_URL):
      //console.log(JSON.stringify(imageData));
      this.file.resolveLocalFilesystemUrl(imageURL)
      .then( (entry) => {
        (<FileEntry>entry).file(file => {
          // this is the actual file as File object
          this.readFile(file);
        });
        console.log(JSON.stringify(entry));
        console.log(entry.toURL());
        this.presentToast('Imagen cargada','success');
        this.nativeImageUrl = entry.toURL();
        this.image = this.webview.convertFileSrc(entry.toURL());
        this.imageArray.push(this.image);
        console.log(this.image);
      })
      .catch(err => {
        this.presentToast('File path resolver error: '+JSON.stringify(err),'danger')
      });
      }, (err) => {
      // Handle error
      this.presentToast('Get image from gallery error: '+JSON.stringify(err),'danger')
      });
  }
  onFileChange(file){
    let reader = new FileReader();
    reader.onload = (event:any) =>{
      this.fileData = event.target.result;
      this.formData.append('document64', this.fileData);
      this.imageArray.push(this.fileData);
      this.formData.append('images[]', this.fileData);
    }
    reader.readAsDataURL(file.target.files[0]); 
    this.nativeImageUrl = "browser";
  }

  sendMessageAsync(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.employeeService.sendMessage(data).subscribe({
        next: res => resolve(res),
        error: err => reject(err)
      });
    });
  }

  async send() {
      this.selectSubject = "sameVoiceEmployee";

      console.info("selectSubject: ",this.selectSubject);
      console.info("otherSubject: ",this.otherSubject);
    if(!this.isEmpty(this.selectSubject)){

      if( ( this.selectSubject != this.otherInputValue ) || ( this.selectSubject === this.otherInputValue && this.otherSubject != '' ) ){

        let data = { 
          comments: this.response.split('\n').join('<br>'), 
          is_anonyme:  this.active ? 'ANONIMO' : 'NO ANONIMO',
          voice_employee_subject_id:  this.selectSubject,
          same_voice_employee: this.voiceEmployee,
          voice_employee_id: this.comment.id, 
          other_subject:  this.selectSubject === this.otherInputValue ? this.otherSubject : undefined
        };
        console.info("data: ",data);
        console.info("commnet: ",this.comment);
        //console.log(this.nativeImageUrl);

        if(this.nativeImageUrl){
          this.formData.append('comments',data.comments);
          this.formData.append('is_anonyme',data.is_anonyme);
          this.formData.append('voice_employee_subject_id',data.voice_employee_subject_id);
          this.formData.append('voice_employee_id', data.voice_employee_id);

          if(typeof data.other_subject !== 'undefined'){
            this.formData.append('other_subject',data.other_subject);
          }
          this.employeeService.sendVoiceEmployee(this.formData).subscribe({
            next: async(res) => {
              if (res.status === 200) {
                this.presentToast('Mensaje enviado', 'success');
                // this.router.navigateByUrl('/employee-voice/employee-voice-sent-modal');
                await this.getComment();
              } else if (res.status === 500) {
                await this.getComment();
                this.presentToast(res.errorMessage, 'danger');
              }
            },
            error: async(err) => {
              await this.getComment();
              this.presentToast('Error al enviar: ' + JSON.stringify(err), 'danger');
            }
          });
          this.presentToast('Mensaje enviado','success');
          setTimeout(async() => {await this.getComment();}, 4000);
          
          console.error("obtener commernt sendVoiceEmployee");
          // setTimeout(() => {this.router.navigateByUrl('dashboard');}, 4000);
        }else{
            try {
              this.presentLoading();
              const response = await this.sendMessageAsync(data);
              console.warn("sendMessageAsync:", response);
              if (response.status === StatusHttp.Success) {
                this.presentToast('Mensaje enviado', 'success');
                await this.getComment(); // asegúrate de que también devuelve Promise correctamente
                console.error("obtener comment sendMessage");
                setTimeout(() => {this.router.navigateByUrl('dashboard');}, 4000);
              } else if (response.status === StatusHttp.ServerError) {
                this.presentToast(response.errorMessage, 'danger');
              }
            } catch (error) {
              console.error("Error al enviar o al obtener comentario", error);
              this.presentToast('Ocurrió un error inesperado', 'danger');
            } finally {
              this.dismissLoading();
            }
        }
      }else{
        console.log('Tema');
        this.presentToast('Debe establecer un tema o asunto','danger');
      }
    }else{
      this.presentToast('Debe establecer un tema o asunto','danger');
    }
  }

  //Alerts
  // Presenta el toast con el error
  async presentToast(msg,color) {
    const toast = await this.toastController.create({
        message: msg,
        duration: 5000,
        position: 'top',
        color: color,
        cssClass: 'toast',
    });
    toast.present();
  }

  private readFile(file: any) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const formData = new FormData();
      const imgBlob = new Blob([reader.result], { type: file.type });
      this.formData.append('document', imgBlob, file.name);
      this.formData.append('images[]', imgBlob, file.name);
    };
    reader.readAsArrayBuffer(file);
  }
  isEmpty(str) {
    return (!str || str.length === 0 );
  }
  async presentLoading() {
    this.isLoading = true;
    return await this.loadingCtrl.create({
    }).then((a) => {
      a.present().then(() => {
        if (!this.isLoading) {
          a.dismiss();
        }
      });
    });
  }
  // Cierre del loading
  async dismissLoading() {
    this.isLoading = false;
    return await this.loadingCtrl.dismiss();
  }
  scrollToBottom() {
    if (this.content) {
      this.content.scrollToBottom(300); // scroll suave en 300ms
    }
  }
}